
import Vue from 'vue';
import ExpandIcon from '@/components/Icons/ExpandIcon.vue';
import CollapseIcon from '@/components/Icons/CollapseIcon.vue';
export default Vue.extend({
  name: 'AsCollapse',
  components: {
    ExpandIcon,
    CollapseIcon,
  },
  props: {
    title: String,
    collapsible: { type: Boolean, default: true },
    openByDefault: { type: Boolean, default: true },
  },
  data() {
    return {
      open: this.collapsible ? this.openByDefault : true,
    };
  },
  methods: {
    shouldToggleOpen() {
      if (this.collapsible) this.open = !this.open;
    },
    onKey(event: KeyboardEvent) {
      if (event.key == 'Enter') this.shouldToggleOpen();
    },
  },
});
